export default __webpack_public_path__ + "static/media/creator2.7e00a961.jpeg";